import PropTypes from 'prop-types';
import { getCountdownTillDate } from '../../Helper/CountdownHelper';
import Translations from '../../../utils/Translations';
import { Component } from 'react';

class ProfileLiveShowCountdown extends Component {
	constructor(props) {
		super(props);

		this.state = {
			countdown: this.getCountdown(),
		};

		this.ended = new Date(this.props.end) < new Date();
		this.interval = null;

		this.getCountdown = this.getCountdown.bind(this);
		this.startInterval = this.startInterval.bind(this);
	}

	componentDidMount() {
		this.startInterval();
	}

	componentDidUpdate(nextProps) {
		if (nextProps !== this.props) {
			const { days, hours, mins, hasStarted } = this.getCountdown();
			this.setState({ countdown: { days, hours, mins, hasStarted } });
		}
	}

	componentWillUnmount() {
		window.clearInterval(this.interval);
	}

	startInterval() {
		const { isDone } = getCountdownTillDate(this.props.end);
		if (!isDone) {
			this.interval = setInterval(() => {
				const { days, hours, mins, hasStarted } = this.getCountdown();
				if (!this.state.countdown.hasStarted && hasStarted) {
					this.props.setHasStarted(hasStarted);
				}
				this.setState({ countdown: { days, hours, mins, hasStarted } });
			}, 1000);
		}
	}

	getCountdown() {
		const hasStarted = new Date(this.props.start) <= new Date() || this.props.hasStarted;
		const { days, hours, mins } = getCountdownTillDate(hasStarted ? this.props.end : this.props.start, true);
		return { days, hours, mins, hasStarted };
	}

	render() {
		const hasEnded = new Date(this.props.end) < new Date();
		if (hasEnded) {
			if (!this.ended && typeof this.props.onEnd === 'function') {
				this.ended = true;
				this.props.onEnd();
			}

			return this.props.children ? this.props.children : null;
		}

		const { days, hours, mins, hasStarted } = this.state.countdown;
		const showDays = (this.props.isHeader && parseInt(days) > 0) || !this.props.isHeader;
		return (
			<div className={'profile-live-show__countdown-wrapper'}>
				{!this.props.isHeader && (
					<div className="profile-live-show__countdown-title">
						{hasStarted ? Translations.get('cam_shows.show-end-in') : Translations.get('cams_shows.show-start-in')}
					</div>
				)}
				<div className={this.props.isHeader ? 'profile-header-live-show__countdown' : 'profile-live-show__countdown'}>
					{showDays && <span>{days}</span>}
					{showDays && <span>{parseInt(days) === 1 ? Translations.get('DateDay') : Translations.get('Days')}</span>}
					<span>{hours}</span>
					<span>{Translations.get('HoursShort')}</span>
					<span>{mins}</span>
					<span>{Translations.get('MinutesShort')}</span>
				</div>
			</div>
		);
	}
}

ProfileLiveShowCountdown.propTypes = {
	children: PropTypes.node,
	start: PropTypes.string,
	end: PropTypes.string,
	hasStarted: PropTypes.bool,
	setHasStarted: PropTypes.func,
	isHeader: PropTypes.bool,
	onEnd: PropTypes.func,
};

ProfileLiveShowCountdown.defaultProps = {
	isHeader: false,
	onEnd: null,
};

export default ProfileLiveShowCountdown;
